import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ConstantState, featureKey } from "./constants.reducers";

const constantSelector = createFeatureSelector<ConstantState>(featureKey);

export const sourceSelector = createSelector(constantSelector, state => state.sources);
export const riskLevelSelector = createSelector(constantSelector, state => state.riskLevels);
export const prioritySelector = createSelector(constantSelector, state => state.priorities);